// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Icons: NavItemType = {
  id: 'group-icons',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'icons',
      title: 'Icons',
      type: 'collapse',

      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'icons-wells',
          title: 'Wells',
          type: 'item',
          url: '/icons/wells'
        },
        {
          id: 'icons-logs',
          title: 'Logs',
          type: 'item',
          url: '/icons/logs'
        },
        {
          id: 'icons-tops',
          title: 'Tops',
          type: 'item',
          url: '/icons/tops'
        },
        {
          id: 'icons-polys',
          title: 'Polys',
          type: 'item',
          url: '/icons/polys'
        },
        {
          id: 'icons-points',
          title: 'Points',
          type: 'item',
          url: '/icons/points'
        },
        {
          id: 'icons-grid',
          title: 'Grid',
          type: 'item',
          url: '/icons/grid'
        },
        {
          id: 'icons-faults',
          title: 'Faults',
          type: 'item',
          url: '/icons/faults'
        },
        {
          id: 'icons-properties',
          title: 'Properties',
          type: 'item',
          url: '/icons/properties'
        }
      ]
    }
  ]
};

export default Icons;
